import {
  APP_DEEP_LINK_SCHEME,
  ANDROID_APP_URL,
  IOS_APP_URL,
  WINDOWS_APP_URL,
  MAC_APP_URL,
  LINUX_APP_URL,
} from "./constants/configs";

const FALLBACK_DELAY_MS = 2500;

function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

function isAndroid() {
  return /Android/.test(navigator.userAgent);
}

function isWindows() {
  return /Win/.test(navigator.platform) || /Windows/.test(navigator.userAgent);
}

function isMacDesktop() {
  // Exclude iOS devices that report MacIntel with touch
  const isMacPlatform = /Macintosh|MacIntel|Mac OS X/.test(
    navigator.userAgent
  );
  const isTouchMac =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return isMacPlatform && !isTouchMac;
}

function isLinuxDesktop() {
  return /Linux/.test(navigator.userAgent) && !isAndroid();
}

/**
 * Open the ePrakashak mobile app (if installed) or fall back to App Store / Play Store.
 * Call this when the user taps "Open in ePrakashak app" after book assignment.
 * @param {string} [qrId] - Optional qrId to open app to qr-details (e.g. after assignment)
 */
export function openMobileAppOrStore(qrId) {
  const search = qrId ? `?qrId=${qrId}` : "";

  // On mobile platforms, first attempt to open the app via deep link,
  // then fall back to the respective store if it doesn't open.
  if (isAndroid() || isIOS()) {
    const deepLink = qrId
      ? `${APP_DEEP_LINK_SCHEME}qr-details${search}`
      : APP_DEEP_LINK_SCHEME;

    window.location.href = deepLink;

    setTimeout(() => {
      if (document.hidden) return;
      if (isAndroid()) {
        window.location.href = ANDROID_APP_URL;
      } else if (isIOS()) {
        window.location.href =
          IOS_APP_URL || "https://apps.apple.com/search?term=eprakashak";
      }
    }, FALLBACK_DELAY_MS);
    return;
  }

  // Desktop / non-mobile – go directly to the platform-specific store / download
  if (isWindows() && WINDOWS_APP_URL) {
    window.open(WINDOWS_APP_URL, "_blank");
  } else if (isMacDesktop() && MAC_APP_URL) {
    window.open(MAC_APP_URL, "_blank");
  } else if (isLinuxDesktop() && LINUX_APP_URL) {
    window.open(LINUX_APP_URL, "_blank");
  } else if (ANDROID_APP_URL) {
    // Generic fallback – open Play Store page
    window.open(ANDROID_APP_URL, "_blank");
  }
}
